const defaultProposalSign = [];

const proposalSign = (state = defaultProposalSign, action) => {
  switch (action.type) {
    case 'GET_PROPOSAL_BY_KEY_SUCCESS':
      return { ...action.proposal };
    case 'PROPOSAL_SIGN_FIELD_UPDATE':
      const { name, value } = action;
      const newMeta = { ...state.meta, [name]: value, };
      return {
        ...state,
        meta: newMeta,
      };
    default:
      return state;
  }
};

export default proposalSign;
